// @ts-strict-ignore

import { ErrorWithUi } from 'errors';

import { castArray } from 'lodash';
import { action, observable, makeObservable } from 'mobx';

import { RootStore } from './rootStore';

interface ErrorActionOption {
  actionText: string;
  actionCallback: () => void;
}

interface ErrorActions {
  errorAction?: ErrorActionOption;
  additionalAction?: ErrorActionOption;
  cancelAction?: Omit<ErrorActionOption, 'actionCallback'>;
}

export default class UiStore {
  rootStore: RootStore;

  @observable
  error: Error | ErrorWithUi;

  @observable
  errorDescription: string[];

  @observable
  cancelAction?: Omit<ErrorActionOption, 'actionCallback'>;

  @observable
  action: ErrorActionOption;

  @observable
  additionalAction?: ErrorActionOption;

  @observable
  isIntro: boolean;

  @observable
  isNotificationPanelOpen: boolean = false;

  @observable
  bulkInviteToastId: string | number = '';

  constructor(rootStore: RootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @action
  postError = (
    error: Error,
    errorDescription: string | string[] = null,
    actions?: ErrorActions
  ) => {
    this.error = error;
    this.errorDescription = errorDescription ? castArray(errorDescription) : null;
    this.action = actions?.errorAction;
    this.additionalAction = actions?.additionalAction;
    this.cancelAction = actions?.cancelAction;
  };

  @action
  clearError = () => {
    this.error = null;
  };

  @action
  setIntro(show: boolean) {
    this.isIntro = show;
  }

  @action
  setIsNotificationPanelOpen(isOpen: boolean) {
    this.isNotificationPanelOpen = isOpen;
  }

  @action
  setBulkInviteToastId(toastId: string | number) {
    this.bulkInviteToastId = toastId;
  }

  @action
  clearBulkInviteToastId = () => {
    this.bulkInviteToastId = '';
  };
}
